import React from 'react';

function BudgetItem({ label, used, total, color }) {
  const pct = total > 0 ? (used / total) * 100 : 0;
  const full = used >= total;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <div style={{ fontFamily: "'Cinzel', serif", fontSize: "11px", color: "#8a7e5e", letterSpacing: "1px", minWidth: 80 }}>
        {label}
      </div>
      <div style={{ width: 100, height: 6, background: "rgba(201,168,76,0.15)", borderRadius: 3, overflow: "hidden" }}>
        <div style={{ width: `${pct}%`, height: "100%", background: full ? "#c9a84c" : color, borderRadius: 3, transition: "width 0.3s" }} />
      </div>
      <div style={{ fontFamily: "'Cinzel', serif", fontSize: "12px", color: full ? "#c9a84c" : "#8a7e5e", minWidth: 40, textAlign: "right" }}>
        {used}/{total}
      </div>
    </div>
  );
}

export default BudgetItem;
